import { MODULE_FAILED_TO_LOAD, PRELOAD_ERROR } from '@/common/utils/bugsnag';

async function retry(fn, retriesLeft = 9, interval = 100) {
  try {
    const result = await fn();

    if (!result) {
      throw new Error(MODULE_FAILED_TO_LOAD);
    }

    return result;
  } catch (error) {
    if (
      error.message &&
      typeof error.message === 'string' &&
      error.message.includes('Loading chunk')
    ) {
      console.error('Error loading component, reloading page:', error);
      console.warn('Chunk loading failed, reloading page...');

      throw error;
    }

    console.error(`Error loading component, retries left: ${retriesLeft}`, error);

    if (retriesLeft > 1) {
      await new Promise(resolve => setTimeout(resolve, interval));
      return retry(fn, retriesLeft - 1, interval);
    } else {
      const error = new Error(PRELOAD_ERROR);
      const event = new CustomEvent('vite:preloadError', {
        detail: error
      });
      window.dispatchEvent(event);

      throw error;
    }
  }
}

export default retry;
